import { useMemo } from 'react';

import { RadioGroup, RadioGroupItem, SecondaryText, StyledFlex } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { translationKeys } from '../../translations';

import {
   AiAssistantMainMenuTileItemIdleSoundSourceFormController,
   SoundSource,
} from './AiAssistantMainMenuTileItemIdleSoundSourceForm.types';
import { AiAssistantMainMenuTileItemIdleSoundSourceMicrophoneSelect } from './AiAssistantMainMenuTileItemIdleSoundSourceMicrophoneSelect';
import { AiAssistantMainMenuTileItemIdleSoundSourceMicrophoneLevel } from './AiAssistantMainMenuTileItemIdleSoundSourceMicrophoneLevel';
import { StyledOptions } from './AiAssistantMainMenuTileItemIdleSoundSourceRadioGroup.styled';

const t = translationKeys.mainMenuTileItem;

const createRadioGroupItems = (soundSource: SoundSource | undefined): RadioGroupItem<SoundSource>[] => [
   {
      id: 'COMPUTER',
      label: (
         <StyledFlex direction={'column'} gap={4}>
            <Translate>{t.soundSourceMap.COMPUTER}</Translate>
            {soundSource === 'PHONE' ? null : (
               <StyledOptions direction={'column'} gap={4}>
                  <AiAssistantMainMenuTileItemIdleSoundSourceMicrophoneSelect />
                  <AiAssistantMainMenuTileItemIdleSoundSourceMicrophoneLevel />
               </StyledOptions>
            )}
         </StyledFlex>
      ),
   },
   {
      id: 'PHONE',
      label: (
         <StyledFlex direction={'column'} gap={0}>
            <Translate>{t.soundSourceMap.PHONE}</Translate>
            {soundSource === 'PHONE' ? null : (
               <SecondaryText testId={'phoneDescription'} text={t.soundSource.phoneDescription} compact />
            )}
         </StyledFlex>
      ),
   },
];

type AiAssistantMainMenuTileItemIdleSoundSourceRadioGroupProps = Pick<
   AiAssistantMainMenuTileItemIdleSoundSourceFormController,
   'register'
> &
   Readonly<{ soundSource: SoundSource | undefined }>;

export const AiAssistantMainMenuTileItemIdleSoundSourceRadioGroup = (
   props: AiAssistantMainMenuTileItemIdleSoundSourceRadioGroupProps
): JSX.Element => {
   const radioGroupItems = useMemo(() => createRadioGroupItems(props.soundSource), [props.soundSource]);

   return (
      <RadioGroup
         testId={'soundSource'}
         label={t.soundSource.label}
         defaultValue={'COMPUTER'}
         controller={props.register('soundSource')}
         items={radioGroupItems}
      />
   );
};
